/* eslint-disable import/prefer-default-export */

import FormData from "form-data";

import { authApi } from "api/base";

const getAll = (params) => authApi.get("/media", { params });

const get = (id) => authApi.get(`/media/${id}`);

const upload = (file, size) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("size", size);
  return authApi.post("/media", fd);
};

export { getAll, get, upload };
